export { default } from './FagContentItemPopUp';



// WEBPACK FOOTER //
// ./src/components/FaqContents/FagContentItemPopUp/index.js